import { getMixer as m } from "./atoms-v2980.js";
import { mixNumber as t } from "./atoms-v2981.js";
function o(e, r, i) {
  return typeof e == "number" && typeof r == "number" && typeof i == "number" ? t(e, r, i) : m(e)(e, r);
}
export {
  o as mix
};
